export interface MyUserSurveysProps {
  tab: MyUserSurveysTabType;
  title?: string;
}

export enum MyUserSurveysTabType {
  Surveys = 'surveys',
  ActionPlans = 'action-plans',
}
